import type { BackgroundColorToken } from '@canvas/constants/colors/tokens-types';
import { getTelepointerColorTokenForCollaborator } from '@canvas/constants/get-color-value';
import type { Identity } from '@canvas/model/identity';

import { COLORS_TO_OMIT } from './constants';

export const createParticipantFromIdentity = (
  identity: Identity,
  clientId: number
): Participant => {
  return {
    identity,
    colorToken: getTelepointerColorTokenForCollaborator(clientId, COLORS_TO_OMIT),
  };
};

export interface Participant {
  identity: Identity;
  colorToken: BackgroundColorToken;
}
